export default __webpack_public_path__ + "static/media/wakeAbird.dcb3d441.svg";